"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialUserspaces = exports.roundToCents = void 0;
const gearbox_1 = require("@busy-human/gearbox");
const Transactions_1 = require("../Transactions");
const PaymentMethods_1 = require("../PaymentMethods");
function roundToCents(amount) {
    return Math.ceil(amount * 100) / 100;
}
exports.roundToCents = roundToCents;
var FinancialUserspaces;
(function (FinancialUserspaces) {
    let AccountBalanceType;
    (function (AccountBalanceType) {
        // AVAILABLE
        /** Actual money currently available in the user's stripe account */
        AccountBalanceType["stripeBalance"] = "stripeBalance";
        /** Not visible to user; Transfers from elsewhere in the system to the user's stripe account (e.g. the trust) */
        AccountBalanceType["pendingTransfersIn"] = "pendingTransfersIn";
        /** Payments being held in Opt's trust account, not yet distributed ot the user */
        AccountBalanceType["earningsInTrust"] = "earningsInTrust";
        /** Fees added to the user's account to pay stripe's fee for payout */
        AccountBalanceType["feesOwed"] = "feesOwed";
        // PENDING
        /** Payments not yet earned through uncompleted meetings */
        AccountBalanceType["unearnedPayments"] = "unearnedPayments";
        /** Not visible to user; Payments made to other users using the user's stripe account balance */
        AccountBalanceType["pendingOptBalancePayments"] = "pendingOptBalancePayments";
        /** Transfers being made from a stripe account to another stripe account */
        AccountBalanceType["pendingTransfersOut"] = "pendingTransfersOut";
        /** Money that was removed due to not matching the user's stripe account balance */
        AccountBalanceType["stripeDiscrepancy"] = "stripeDiscrepancy";
        // OTHER PENDING (HIDDEN TO USERS)
        /** Pending payouts */
        AccountBalanceType["pendingPayouts"] = "pendingPayouts";
        /** Not visible to user; Pendingpayments being paid by the user to another user, from an external payment method */
        AccountBalanceType["pendingExtPayments"] = "pendingExtPayments";
        // OTHER TRACKING
        /** Total amount user has earned using Opt */
        AccountBalanceType["totalEarnings"] = "totalEarnings";
        /** Total amount user has paid through Opt */
        AccountBalanceType["totalPaymentsMade"] = "totalPaymentsMade";
        /** When Opt pays OUT excess fees that it cannot recouperate (over the estimated fee) we add those up here */
        AccountBalanceType["extraFeeConvertedEarnings"] = "extraFeeConvertedEarnings";
    })(AccountBalanceType = FinancialUserspaces.AccountBalanceType || (FinancialUserspaces.AccountBalanceType = {}));
    function Defaults() {
        return {
            // AVAILABLE
            stripeBalance: 0,
            pendingTransfersIn: 0,
            earningsInTrust: 0,
            feesOwed: 0,
            // PENDING
            unearnedPayments: 0,
            pendingOptBalancePayments: 0,
            pendingTransfersOut: 0,
            stripeDiscrepancy: 0,
            // OTHER PENDING (HIDDEN TO USERS)
            pendingPayouts: 0,
            pendingExtPayments: 0,
            // OTHER TRACKING
            totalEarnings: 0,
            totalPaymentsMade: 0,
            extraFeeConvertedEarnings: 0,
            // User Fee
            userFeePercent: 15,
            stripe: {
                customerId: null,
                accountId: null,
                productId: null,
                charges_enabled: false,
                payouts_enabled: false,
                details_submitted: false
            }
        };
    }
    FinancialUserspaces.Defaults = Defaults;
    /**
     * The sum of unearned payments, minus pending payouts to their account
     * @param data
     * @returns
     */
    function pendingBalance(data) {
        return roundToCents(data.unearnedPayments + data.stripeDiscrepancy - data.pendingOptBalancePayments - data.feesOwed);
    }
    FinancialUserspaces.pendingBalance = pendingBalance;
    /** The sum of the actual stripe balance and money being held in the trust on user's behalf */
    function availableBalance(data) {
        return roundToCents(data.stripeBalance + data.pendingTransfersIn + data.earningsInTrust);
    }
    FinancialUserspaces.availableBalance = availableBalance;
    /**  */
    function eventualBalance(data) {
        return roundToCents(pendingBalance(data) + availableBalance(data));
    }
    FinancialUserspaces.eventualBalance = eventualBalance;
    FinancialUserspaces.Relationships = {
        transactions: ["Transactions", Transactions_1.Transactions.CollectionClass],
        paymentmethods: ["PaymentMethods", PaymentMethods_1.PaymentMethods.CollectionClass]
    };
    const MAX_FEE = 50;
    const MIN_FEE = 1;
    const DEFAULT_FEE = 15;
    function getUserFee(data) {
        if (data.userFeePercent || data.userFeePercent == 0) {
            if (data.userFeePercent > MAX_FEE)
                return MAX_FEE;
            else if (data.userFeePercent < MIN_FEE)
                return MIN_FEE;
            else
                return data.userFeePercent;
        }
        else {
            return DEFAULT_FEE;
        }
    }
    FinancialUserspaces.getUserFee = getUserFee;
    class CollectionClass extends gearbox_1.CollectionEntity {
        constructor() {
            super(...arguments);
            this.relationships = FinancialUserspaces.Relationships;
        }
        promisePaymentAccountForUser(optUserId) {
            return __awaiter(this, void 0, void 0, function* () {
                const doc = yield this.fetchDoc(optUserId);
                if (!doc) {
                    return this.add({}, { id: optUserId });
                }
                else {
                    return doc;
                }
            });
        }
        defaults() {
            return Defaults();
        }
    }
    FinancialUserspaces.CollectionClass = CollectionClass;
    FinancialUserspaces.Collection = new CollectionClass({ path: '/FinancialUserspaces' });
})(FinancialUserspaces = exports.FinancialUserspaces || (exports.FinancialUserspaces = {}));
//# sourceMappingURL=index.js.map